<template>
  <div class="platform-shell" :class="layoutClass">
    <aside class="platform-shell__sidebar">
      <platformTable />
    </aside>
    <div class="platform-shell__right">
      <PlatformNavbar :title="title" />
      <main class="platform-shell__main">
        <div class="platform-page__body">
          <GuestBanner v-if="showGuestBanner" />
          <slot />
        </div>
      </main>
    </div>
  </div>
</template>

<script>
import platformTable from '@/components/platformTable.vue';
import PlatformNavbar from '@/components/platform/PlatformNavbar.vue';
import GuestBanner from '@/components/guest/banner.vue';

export default {
  name: 'PlatformLayout',
  components: { platformTable, PlatformNavbar, GuestBanner },
  props: {
    title: {
      type: String,
      default: '',
    },
    layoutClass: {
      type: String,
      default: 'mainStyle1',
    },
    showGuestBanner: {
      type: Boolean,
      default: true,
    },
  },
};
</script>
